import React, { Component } from "react";
import { Link } from "react-router-dom";

import styled from "styled-components";

import DormButton from "./DormButton";

const Dorms = styled.div`
  margin: 0 auto;
  padding: 0 1.5rem;
  margin-top: 2vh;
  overflow: scroll;
  max-height: 70vh;
  background-color: #F2F2F2;
  display: grid;
  grid-column-gap: 5px;
  grid-template-columns: 1fr 1fr;
  @media only screen and (min-width: 768px) {
    grid-template-columns: ${props => props.mapOpen ? '1fr 1fr' : '1fr 1fr 1fr 1fr'};
  }
`;

const DormLink = styled(Link)`
  text-align: left;
`;

export default class ExploreSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dorms: this.props.dorms,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      this.setState({ dorms: this.props.dorms });
    }
  }

  render() {
    return (
      <div>
        <Dorms mapOpen={this.props.mapOpen}>
          {this.state.dorms.map((dorm, index) => (
            <DormLink
              key={index}
              to={"/explore/" + dorm.DORM.replace(/\s+/g, "-")}
              style={{ textDecoration: "none" }}
            >
              <DormButton
                key={index}
                school={dorm.COLLEGE}
                name={dorm.DORM}
                image={dorm.IMAGE_LINK}
                class_makeup={dorm.CLASS_MAKEUP}
                SINGLE_={dorm.SINGLE_}
                DOUBLE_={dorm.DOUBLE_}
                WALKTHROUGH={dorm.WALKTHROUGH}
                TRIPLE_={dorm.TRIPLE_}
                BUILDING_TYPE_={dorm.BUILDING_TYPE_}
                onMapClick={this.props.onMapButtonClick}
              />
            </DormLink>
          ))}
        </Dorms>
      </div>
    );
  }
}
